

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './ExamPage.css';
// import { useLocation } from 'react-router-dom';

// const ExamPage = () => {
//   const location = useLocation();
//   const studentId = location.state?.studentid;
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [submitted, setSubmitted] = useState(false);

//   const EXAM_DURATION = 60 * 60 * 1000; // 1 hour in ms
//   const userId = studentId ;
//   const STORAGE_KEY = `exam_start_time_${userId}`;

//   // Fetch questions
//   useEffect(() => {
//     // console.log("saji",studentId)
//     axios.get(`${process.env.REACT_APP_API}/questions/getexamquestions/${userId}`)
//       .then(res => setQuestions(res.data))
//       .catch(err => console.error(err));
//   }, [userId]);

//   // Timer logic
//   useEffect(() => {
//     let startTime = localStorage.getItem(STORAGE_KEY);
//     if (!startTime) {
//       startTime = Date.now();
//       localStorage.setItem(STORAGE_KEY, startTime);
//     } else {
//       startTime = parseInt(startTime);
//     }

//     const interval = setInterval(() => {
//       const now = Date.now();
//       const diff = EXAM_DURATION - (now - startTime);
//       if (diff <= 0 && !submitted) {
//         clearInterval(interval);
//         setTimeLeft(0);
//         handleSubmit(); // auto-submit
//       } else {
//         setTimeLeft(Math.floor(diff / 1000));
//       }
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [submitted]);

//   const formatTime = (seconds) => {
//     const min = Math.floor(seconds / 60).toString().padStart(2, '0');
//     const sec = (seconds % 60).toString().padStart(2, '0');
//     return `${min}:${sec}`;
//   };

//   const handleOptionChange = (questionId, selectedOption) => {
//     setAnswers({ ...answers, [questionId]: selectedOption });
//   };

//   const saveAnswerToDB = async (questionId, selectedOption) => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API}/questions/save-answer`, {
//         studentId: userId,
//         questionId,
//         selectedOption,
//       });
//     } catch (err) {
//       console.error('Error saving answer:', err);
//     }
//   };

//   const handleNext = async () => {
//     const question = questions[currentIndex];
//     const selectedOption = answers[question.id];
//     if (selectedOption) {
//       await saveAnswerToDB(question.id, selectedOption);
//     }

//     if (currentIndex < questions.length - 1) {
//       setCurrentIndex(currentIndex + 1);
//     }
//   };

//   const handleSubmit = async () => {
//     setSubmitted(true);
//     localStorage.removeItem(STORAGE_KEY);

//     try {
//       // Save all answers before submission
//       for (const [questionId, selectedOption] of Object.entries(answers)) {
//         await saveAnswerToDB(parseInt(questionId), selectedOption);
//       }

//       // Submit and mark exam as completed
//       const response = await axios.post(`${process.env.REACT_APP_API}/questions/submit-exam`, {
//         studentId: userId,
//         markCompleted: true,
//       });

//       alert(`Exam submitted. Your score is ${response.data.score}`);
//     } catch (error) {
//       console.error(error);
//       alert('Failed to submit exam.');
//     }
//   };

//   if (questions.length === 0) {
//     return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
//   }

//   const currentQuestion = questions[currentIndex];
//   const selectedAnswer = answers[currentQuestion.id];

//   return (
//     <div className="exam-container">
//       <div className="exam-header">
//         <h2>Online Exam</h2>
//         <h3 className={`timer ${timeLeft <= 60 ? 'warning' : ''}`}>
//           Time Left: {formatTime(timeLeft)}
//         </h3>
//       </div>

//       <p className="question-number">
//         Question {currentIndex + 1} of {questions.length}
//       </p>

//       <div>
//         <h4 className="question-text">{currentQuestion.question}</h4>
//         {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => (
//           <label
//             key={opt}
//             className={`option-label ${selectedAnswer === opt ? 'selected' : ''}`}
//           >
//             <input
//               type="radio"
//               name={`q${currentQuestion.id}`}
//               value={opt}
//               checked={selectedAnswer === opt}
//               onChange={() => handleOptionChange(currentQuestion.id, opt)}
//               style={{ marginRight: '10px' }}
//             />
//             {currentQuestion[opt]}
//           </label>
//         ))}
//       </div>

//       <div className="nav-buttons">
//         {currentIndex === questions.length - 1 ? (
//           <button
//             className="btn btn-submit"
//             onClick={handleSubmit}
//             disabled={submitted || !selectedAnswer}
//           >
//             Submit Exam
//           </button>
//         ) : (
//           <button
//             className="btn btn-next"
//             onClick={handleNext}
//             disabled={!selectedAnswer}
//           >
//             Next
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ExamPage;






// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './ExamPage.css';
// import { useLocation, useNavigate } from 'react-router-dom';

// const ExamPage = () => {
//   const location = useLocation();
//   const studentId = location.state?.studentid;
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [timeLeft, setTimeLeft] = useState(0);
//   const [submitted, setSubmitted] = useState(false);
//   const navigate =useNavigate()
//   const EXAM_DURATION = 60 * 60 * 1000; // 1 hour in ms
//   const userId = studentId;
//   const STORAGE_KEY_TIME = `exam_start_time_${userId}`;
//   const STORAGE_KEY_INDEX = `current_index_${userId}`;

//   // Fetch questions and current index
//   useEffect(() => {
//     axios
//       .get(`${process.env.REACT_APP_API}/questions/getexamquestions/${userId}`)
//       .then(res => {
//         setQuestions(res.data);

//         // Get saved index from localStorage
//         const savedIndex = parseInt(localStorage.getItem(STORAGE_KEY_INDEX), 10);
//         if (!isNaN(savedIndex) && savedIndex < res.data.length) {
//           setCurrentIndex(savedIndex);
//         } else {
//           setCurrentIndex(0);
//         }
//       })
//       .catch(err => console.error(err));
//   }, [userId]);

//   // Timer logic
//   useEffect(() => {
//     let startTime = localStorage.getItem(STORAGE_KEY_TIME);
//     if (!startTime) {
//       startTime = Date.now();
//       localStorage.setItem(STORAGE_KEY_TIME, startTime);
//     } else {
//       startTime = parseInt(startTime);
//     }

//     const interval = setInterval(() => {
//       const now = Date.now();
//       const diff = EXAM_DURATION - (now - startTime);
//       if (diff <= 0 && !submitted) {
//         clearInterval(interval);
//         setTimeLeft(0);
//         handleSubmit(); // auto-submit
//       } else {
//         setTimeLeft(Math.floor(diff / 1000));
//       }
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [submitted]);

//   const formatTime = (seconds) => {
//     const min = Math.floor(seconds / 60).toString().padStart(2, '0');
//     const sec = (seconds % 60).toString().padStart(2, '0');
//     return `${min}:${sec}`;
//   };

//   const handleOptionChange = (questionId, selectedOption) => {
//     setAnswers(prev => ({ ...prev, [questionId]: selectedOption }));
//   };

//   const saveAnswerToDB = async (questionId, selectedOption) => {
//     try {
//       await axios.post(`${process.env.REACT_APP_API}/questions/save-answer`, {
//         studentId: userId,
//         questionId,
//         selectedOption,
//       });
//     } catch (err) {
//       console.error('Error saving answer:', err);
//     }
//   };

//   const handleNext = async () => {
//     const question = questions[currentIndex];
//     const selectedOption = answers[question.id];
//     if (selectedOption) {
//       await saveAnswerToDB(question.id, selectedOption);
//     }

//     if (currentIndex < questions.length - 1) {
//       const newIndex = currentIndex + 1;
//       setCurrentIndex(newIndex);
//       localStorage.setItem(STORAGE_KEY_INDEX, newIndex);
//     }
//   };

//   const handleSubmit = async () => {
//     setSubmitted(true);
//     localStorage.removeItem(STORAGE_KEY_TIME);
//     localStorage.removeItem(STORAGE_KEY_INDEX);

//     try {
//       for (const [questionId, selectedOption] of Object.entries(answers)) {
//         await saveAnswerToDB(parseInt(questionId), selectedOption);
//       }

//       // const response = await axios.post(`${process.env.REACT_APP_API}/questions/submit-exam`, {
//       //   studentId: userId,
//       //   markCompleted: true,
//       //   timeCompleted:timeLeft,
//       // });

//       // const timeTaken = Math.floor((EXAM_DURATION - timeLeft * 1000) / 1000); // in seconds
//        const totalSeconds = Math.floor((EXAM_DURATION - timeLeft * 1000) / 1000);
//     const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
//     const seconds = (totalSeconds % 60).toString().padStart(2, '0');
//     const timeTakenFormatted = `${minutes}:${seconds}`;

// const response = await axios.post(`${process.env.REACT_APP_API}/questions/submit-exam`, {
//   studentId: userId,
//   markCompleted: true,
//    timeTaken: timeTakenFormatted,
//   // timeTaken,
// });

//       console.log(response.data)

//       // alert(`Exam submitted. Your score is ${response.data.score}`);
//          alert(`Exam submitted`);
//          navigate('/profile')
//     } catch (error) {
//       console.error(error);
//       alert('Failed to submit exam.');
//     }
//   };

//   if (questions.length === 0) {
//     return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
//   }

//   const currentQuestion = questions[currentIndex];
//   const selectedAnswer = answers[currentQuestion.id];

//   return (
//     <div className="exam-container">
//       <div className="exam-header">
//         <h2>Online Exam</h2>
//         <h3 className={`timer ${timeLeft <= 60 ? 'warning' : ''}`}>
//           Time Left: {formatTime(timeLeft)}
//         </h3>
//       </div>

//       <p className="question-number">
//         Question {currentIndex + 1} of {questions.length}
//       </p>

//       <div>
//         <h4 className="question-text">{currentQuestion.question}</h4>
//         {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => (
//           <label
//             key={opt}
//             className={`option-label ${selectedAnswer === opt ? 'selected' : ''}`}
//           >
//             <input
//               type="radio"
//               name={`q${currentQuestion.id}`}
//               value={opt}
//               checked={selectedAnswer === opt}
//               onChange={() => handleOptionChange(currentQuestion.id, opt)}
//               style={{ marginRight: '10px' }}
//             />
//             {currentQuestion[opt]}
//           </label>
//         ))}
//       </div>

//       <div className="nav-buttons">
//         {currentIndex === questions.length - 1 ? (
//           <button
//             className="btn btn-submit"
//             onClick={handleSubmit}
//             disabled={submitted || !selectedAnswer}
//           >
//             Submit Exam
//           </button>
//         ) : (
//           <button
//             className="btn btn-next"
//             onClick={handleNext}
//             disabled={!selectedAnswer}
//           >
//             Next
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ExamPage;
















import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ExamPage.css';
import { useLocation, useNavigate } from 'react-router-dom';

const ExamPage = () => {
  const location = useLocation();
  const studentId = location.state?.studentid;
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});
  const [currentIndex, setCurrentIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [examCompleted, setExamCompleted] = useState(false); // ✅ Changed to meaningful name
  const navigate = useNavigate();
 
const [isgov,setisgov]=useState(false)

  // const [examCompleted, setExamCompleted] = useState(false);
const [score, setScore] = useState(null);
const [timeTaken, setTimeTaken] = useState('');

  const EXAM_DURATION = 60 * 60 * 1000;
  const userId = studentId;
  const STORAGE_KEY_TIME = `exam_start_time_${userId}`;
  const STORAGE_KEY_INDEX = `current_index_${userId}`;

  // ✅ Check if exam is already completed
 useEffect(() => {
  const checkExamStatus = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/students/enterexam`, {
        studentid: studentId
      });

      if (response.data.completed) {
        setExamCompleted(true);
        setScore(response.data.score || 0);
        setTimeTaken(response.data.timeTaken || '00:00');
      }
    } catch (error) {
      alert(error.response?.data?.message || "Something went wrong");
    }
  };
  checkExamStatus();
}, [studentId]);


  // ✅ Fetch Questions and Load saved index
  // useEffect(() => {
  //   axios.get(`${process.env.REACT_APP_API}/questions/getexamquestions/${userId}`)
  //     .then(res => {
  //       setQuestions(res.data);
  //       const savedIndex = parseInt(localStorage.getItem(STORAGE_KEY_INDEX), 10);
  //       if (!isNaN(savedIndex) && savedIndex < res.data.length) {
  //         setCurrentIndex(savedIndex);
  //       } else {
  //         setCurrentIndex(0);
  //       }
  //     })
  //     .catch(err => console.error(err));
  // }, [userId]);
  useEffect(() => {
  axios.get(`${process.env.REACT_APP_API}/questions/getexamquestions/${userId}`)
    .then(res => {
      // Normal students: set questions
      setQuestions(res.data);

      const savedIndex = parseInt(localStorage.getItem(STORAGE_KEY_INDEX), 10);
      if (!isNaN(savedIndex) && savedIndex < res.data.length) {
        setCurrentIndex(savedIndex);
      } else {
        setCurrentIndex(0);
      }
    })
    .catch(err => {
      // 👇 GovernmentExam students: status 402
      if (err.response && err.response.status === 402) {
        console.log("🚫 Government Exam detected");
       setisgov(true)
      
        // setExamType("GovernmentExam");
      } else {
        console.error(err);
      }
    });
}, [userId]);


  // ✅ Timer logic
  useEffect(() => {
    let startTime = localStorage.getItem(STORAGE_KEY_TIME);
    if (!startTime) {
      startTime = Date.now();
      localStorage.setItem(STORAGE_KEY_TIME, startTime);
    } else {
      startTime = parseInt(startTime);
    }

    const interval = setInterval(() => {
      const now = Date.now();
      const diff = EXAM_DURATION - (now - startTime);
      if (diff <= 0 && !submitted) {
        clearInterval(interval);
        setTimeLeft(0);
        handleSubmit(); // Auto submit
      } else {
        setTimeLeft(Math.floor(diff / 1000));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [submitted]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60).toString().padStart(2, '0');
    const sec = (seconds % 60).toString().padStart(2, '0');
    return `${min}:${sec}`;
  };

  const handleOptionChange = (questionId, selectedOption) => {
    setAnswers(prev => ({ ...prev, [questionId]: selectedOption }));
  };

  const saveAnswerToDB = async (questionId, selectedOption) => {
    try {
      await axios.post(`${process.env.REACT_APP_API}/questions/save-answer`, {
        studentId: userId,
        questionId,
        selectedOption,
      });
    } catch (err) {
      console.error('Error saving answer:', err);
    }
  };

  const handleNext = async () => {
    const question = questions[currentIndex];
    const selectedOption = answers[question.id];
    if (selectedOption) {
      await saveAnswerToDB(question.id, selectedOption);
    }
    if (currentIndex < questions.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      localStorage.setItem(STORAGE_KEY_INDEX, newIndex);
    }
  };

  const handleSubmit = async () => {
    setSubmitted(true);
    localStorage.removeItem(STORAGE_KEY_TIME);
    localStorage.removeItem(STORAGE_KEY_INDEX);
           const question = questions[currentIndex];
    const selectedOption = answers[question.id];
    try {

       await saveAnswerToDB(question.id, selectedOption);
     



      const totalSeconds = Math.floor((EXAM_DURATION - timeLeft * 1000) / 1000);
      const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
      const seconds = (totalSeconds % 60).toString().padStart(2, '0');
      const timeTakenFormatted = `${minutes}:${seconds}`;

      const response = await axios.post(`${process.env.REACT_APP_API}/questions/submit-exam`, {
        studentId: userId,
        markCompleted: true,
        timeTaken: timeTakenFormatted,
      });

      alert('Exam submitted');
      navigate('/profile');
    } catch (error) {
      console.error(error);
      alert('Failed to submit exam.');
    }
  };

 if (examCompleted) {
  return (
    <div className="exam-container">
      <h2>✅ You have already completed your exam.</h2>
      <h3>🎯 Exam Mark: <span style={{ color: 'green' }}>{score}</span></h3>
      <h3>⏱️ Time Taken: <span style={{ color: 'blue' }}>{timeTaken}</span></h3>
      <button className="btn btn-primary" onClick={() => navigate('/profile')}>
        Go to Profile
      </button>
    </div>
  );
}


  if (questions.length === 0) {
     if (isgov){
    return( <h1 style={{ textAlign: 'center', marginTop: '50px' }}>Exam conducting only for classes VI to XII.</h1>)
   
  }
    return <p style={{ textAlign: 'center', marginTop: '50px' }}>Loading questions...</p>;
  }



  const currentQuestion = questions[currentIndex];
  const selectedAnswer = answers[currentQuestion.id];

  return (
    <div className="exam-container">
      <div className="exam-header">
        <h2>Online Exam</h2>
        <h3 className={`timer ${timeLeft <= 60 ? 'warning' : ''}`}>
          Time Left: {formatTime(timeLeft)}
        </h3>
      </div>

      <p className="question-number">
        Question {currentIndex + 1} of {questions.length}
      </p>

      <div>
        <h4 className="question-text">{currentQuestion.question}</h4>
        {['option_a', 'option_b', 'option_c', 'option_d'].map(opt => (
          <label
            key={opt}
            className={`option-label ${selectedAnswer === opt ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name={`q${currentQuestion.id}`}
              value={opt}
              checked={selectedAnswer === opt}
              onChange={() => handleOptionChange(currentQuestion.id, opt)}
              style={{ marginRight: '10px' }}
            />
            {currentQuestion[opt]}
          </label>
        ))}
      </div>

      <div className="nav-buttons">
        {currentIndex === questions.length - 1 ? (
          <button
            className="btn btn-submit"
            onClick={handleSubmit}
            disabled={submitted || !selectedAnswer}
          >
            Submit Exam
          </button>
        ) : (
          <button
            className="btn btn-next"
            onClick={handleNext}
            disabled={!selectedAnswer}
          >
            Next
          </button>
        )}
      </div>
    </div>
  );
};

export default ExamPage;
